import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import defaultToast from 'src/examples/Toast/default';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  defaultToast,
  React
};